// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Material UI
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { IconButton, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


// Import Pages
import MateDrive from '../../../MateDrive/MateDrive';

// Import Helper
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

// Import Recoil
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';

// Import Icons
import MateDriveIcon from '../../../../assets/icons/moduleIcons/mate-drive-link-icon.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '90%',
        fontSize: '12px',
        backgroundColor: 'rgb(252, 252, 252)'
    },
    label: {
        color: "somecolor"
    }
}));

export default function DeleteFromMateDrive({
    action,
    variables,
    setOpenVariable,
    automId
}) {
    const [openDrive, setOpenDrive] = useState(false);
    const [folderPath, setFolderPath] = useState('');

    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const classes = useStyles();

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.MATE-DRIVE.";

    useEffect(() => {
        if (!action.fields?.path) {
            action.fields.path = { value: '', isRequired: true }
        }
        if (!action.fields?.contentType) {
            action.fields.contentType = { value: 'filePath', isRequired: true }
        }
        setFolderPath(action.fields.path.value);
    }, [action.id])

    const handleShowDrive = () => {
        setOpenDrive(true);
    }

    const selectMateDrive = (v, fromMateDrive) => {

        const field = initialActionsData[action.id]?.fields.path;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("path", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);

        action.fields.path = { value: v, isRequired: true }
        setFolderPath(v)
        setOpenDrive(false);
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "FOLDER-PATH")} is_required />
                <div className="relative">
                    <TextField
                        value={folderPath}
                        // onChange={(e) => setFolderPath(e.target.value)}
                        disabled
                        id="outlined-disabled"
                        placeholder="Click Mate Drive Icon"
                        // label="Click Mate Drive Icon"
                        variant="outlined"
                        className={classes.textField}
                        InputLabelProps={{
                            className: classes.label,
                        }}

                    />
                    {
                        <IconButton className="mate-drive-button" style={{ position: 'absolute' }} onClick={handleShowDrive} >
                            <img src={MateDriveIcon} />
                        </IconButton>
                    }
                </div>


            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "FILE-NAME-AND-EXT")} is_required />
                <TextInput
                    action={action}
                    inputName="fileName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                    fieldType="string"
                    displayName={t(label + 'FILE-NAME-AND-EXT')}
                    hideRequired
                    autom_id={automId}
                />
                <small className="conf-field-desc"><em>Ex: example.txt</em></small>
            </div>
            {
                openDrive && (
                    <MateDrive setOpen={setOpenDrive} flowId={automId} from={'folderPath'} handleOnChange={selectMateDrive} />
                )
            }
        </div>
    );
}
